let commentID = 5;

const commentIdGenerator = () => ++commentID;

export { commentIdGenerator };
